module.exports = __webpack_public_path__ + "static/media/animal-04.ced0630d.png";